import {isNullOrUndefined} from 'util';

export const empty = (value: string) => {
  let isEmpty = !isNullOrUndefined(value);
  isEmpty = isEmpty && value.trim().length === 0;
  return isEmpty;
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/utils/string.ts